import { CgiAuthenticationType, CgiProvider } from "../../interfaces/CGI";
import { PaymentChoice } from "../../interfaces/Payment";
import { PersonContactInfo } from "../../interfaces/Person";
import { Question } from "../../interfaces/Question";
import { FormMode, FormScene, FormState, FormViewState, SetAnswersToQuestionsAction, SetAuthenticationTypeAction, SetAutoStartLinkAction, SetCgiProviderAction, SetContactInformationAction, SetDebugAction, SetEnableMemberCodeFieldAction, SetFormModeAction, SetFormSceneAction, SetFormViewStateAction, SetGivenConsentAction, SetOrderRefAction, SetPaymentInformationAction, SetQrStartTokenAction, SetQuestionnaireAction, SetRequestStartedMillisecondsAction, SetResetFormAction, SetTypeOfMemberAction, SetUmbracoPageIdAction, SetUnionAction, SetUserAgeAction, TypeOfNewMember } from "./types";

export enum FormDataTypes {
    SetFormSceneAction = 'DATA/SETFORMSCENE',
    SetAutoStartLinkAction = 'DATA/SETAUTOSTARTLINK',
    SetOrderRefAction = 'DATA/SETORDERREFACTION',
    SetQrStartTokenAction = 'DATA/SERQRSTARTTOKEN',
    SetRequestStartedMillisecondsAction = 'DATA/SETREQUESTSTARTEDMILLISECONDS',
    SetResetFormAction = 'DATA/SETRESETFORM',
    SetDebugAction = 'DATA/SETDEBUG',
    SetContactInformationAction = 'DATA/SETCONTACTINFORMATION',
    SetAnswersToQuestionsAction = 'DATA/SETANSWERSTOQUESTIONS',
    SetGivenConsentAction = 'DATA/SETGIVENCONSENT',
    SetQuestionnaireAction = 'DATA/SETQUESTIONNAIRE',
    SetPaymentInformation = 'DATA/SETPAYMENTINFORMATION',
    SetFormViewState = 'DATA/SETFORMVIEWSTATE',
    SetUnionState = 'DATA/SETUNIONSTATE',
    SetTypeOfMemberState = 'DATA/SETTYPEOFMEMBER',
    SetUserAgeAction = 'DATA/SETUSERAGE',
    SetAuthenticationType = 'DATA/SETAUTHENTICATIONTYPE',
    SetCgiProvider = 'DATA/SETCGIPROVIDER',
    SetFormMode = 'DATA/SETFORMMODE',
    SetEnableMemberCodeField = 'DATA/SETENABLEMEMBERCODEFIELD',
    SetUmbracoPageId = 'DATA/SETUMBRACOPAGEID',
}

export const setFormScene = (scene: FormScene): SetFormSceneAction => ({
    type: FormDataTypes.SetFormSceneAction,
    payload: { scene },
});

export const setAutostartLink = (autoStartToken: string | undefined): SetAutoStartLinkAction => ({
    type: FormDataTypes.SetAutoStartLinkAction,
    payload: { autoStartLink: autoStartToken },
});

export const setOrderRef = (orderRef: string | undefined): SetOrderRefAction => ({
    type: FormDataTypes.SetOrderRefAction,
    payload: { orderRef },
});

export const setQrStartToken = (qrStartToken: string | undefined): SetQrStartTokenAction => ({
    type: FormDataTypes.SetQrStartTokenAction,
    payload: { qrStartToken },
});

export const setRequestStartedMilliseconds = (requestStartedMilliseconds: number | undefined): SetRequestStartedMillisecondsAction => ({
    type: FormDataTypes.SetRequestStartedMillisecondsAction,
    payload: { requestStartedMilliseconds },
});

export const setAuthenticationType = (authenticationType: CgiAuthenticationType): SetAuthenticationTypeAction => ({
    type: FormDataTypes.SetAuthenticationType,
    payload: { authenticationType }
})

export const setResetForm = (excludedFields?: Partial<FormState>): SetResetFormAction => ({
    type: FormDataTypes.SetResetFormAction,
    payload: excludedFields
})

export const setDebug = (debug: boolean): SetDebugAction => ({
    type: FormDataTypes.SetDebugAction,
    payload: { debug }
})

export const setContactInformation = (info: PersonContactInfo): SetContactInformationAction => ({
    type: FormDataTypes.SetContactInformationAction,
    payload: { info }
})

export const setAnswersToQuestions = (answers: Question[]): SetAnswersToQuestionsAction => ({
    type: FormDataTypes.SetAnswersToQuestionsAction,
    payload: { answers }
})

export const setGivenConsent = (consent: boolean | undefined): SetGivenConsentAction => ({
    type: FormDataTypes.SetGivenConsentAction,
    payload: { consent }
})

export const setQuestionnaire = (questionnaire: Question[]): SetQuestionnaireAction => ({
    type: FormDataTypes.SetQuestionnaireAction,
    payload: { questionnaire }
})

export const setPaymentInformation = (paymentChoice: PaymentChoice): SetPaymentInformationAction => ({
    type: FormDataTypes.SetPaymentInformation,
    payload: { paymentChoice }
})

export const setFormViewState = (formState: Partial<FormViewState>): SetFormViewStateAction => ({
    type: FormDataTypes.SetFormViewState,
    payload: formState
});

export const setUnion = (union: string | undefined): SetUnionAction => ({
    type: FormDataTypes.SetUnionState,
    payload: { union }
});

export const setTypeOfMember = (typeOfMember: TypeOfNewMember): SetTypeOfMemberAction => ({
    type: FormDataTypes.SetTypeOfMemberState,
    payload: { typeOfMember }
})

export const setUserAge = (userAge: number | null): SetUserAgeAction => ({
    type: FormDataTypes.SetUserAgeAction,
    payload: { userAge }
})

export const setCgiProvider = (provider: CgiProvider): SetCgiProviderAction => ({
    type: FormDataTypes.SetCgiProvider,
    payload: { provider }
})

export const setFormMode = (mode: FormMode): SetFormModeAction => ({
    type: FormDataTypes.SetFormMode,
    payload: { mode }
})

export const setEnableMemberCodeField = (enableMemberCodeField: boolean): SetEnableMemberCodeFieldAction => ({
    type: FormDataTypes.SetEnableMemberCodeField,
    payload: { enableMemberCodeField }
})

export const setUmbracoPageId = (id: number | undefined): SetUmbracoPageIdAction => ({
    type: FormDataTypes.SetUmbracoPageId,
    payload: { id }

})